<template>
  <div class="site-layout">
    <site-header class="site-layout__header" />

    <main class="site-layout__content">
      <slot></slot>
    </main>

    <site-footer class="site-layout__footer" />
    <reference-modal />
  </div>
</template>

<script>
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'
import ReferenceModal from './ReferenceModal'

export default {
  components: {
    SiteHeader,
    SiteFooter,
    ReferenceModal
  }
}
</script>

<style lang="scss" scoped>
.site-layout {
  &__footer {
    margin-top: 74px;
  }
}
</style>
